import React, { useContext as useContextCore } from 'react'
import type { RouterType } from '../useHistory'
import type { UseColorModeResult } from './useColorMode'

export type IconType = 'fai' | 'fa6i' | 'bi'
export type Colors = {
  primary?: string
  primary75?: string
  primary50?: string
  primary25?: string
}

export enum ColorModeEnum {
  light = 'light',
  dark = 'dark',
  system = 'system',
}

export type ThemeContextType = {
  iconType?: IconType
  routerType?: RouterType
  colors?: Colors
  colorMode?: UseColorModeResult
}

export const ThemeContext = React.createContext<ThemeContextType>({
  iconType: 'fa6i',
  routerType: 'react-router',
})

export const useTheme = () => useContextCore(ThemeContext)
